"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIEN_DOCUMENT_CONDITION_TASK_TYPE_BY_REASON = exports.isAttributeScopedPendingDocumentTaskType = exports.isLienDocumentConditionTaskType = exports.LIEN_DOCUMENT_CONDITION_REASON_BY_TASK_TYPE = exports.FraudPendingDocumentCategoryLabel = exports.OWED_FRAUD_PENDING_DOCUMENT_CATEGORY_REVIEW_STATUSES = exports.FraudPendingDocumentCategoryReviewStatus = exports.FraudPendingDocumentPreviouslyUploadedStatus = exports.HUMAN_READABLE_REJECTION_REASON = exports.REJECTION_REASONS_BY_PENDING_DOCUMENT_TASK_TYPE = exports.ALL_DOCUMENT_REJECTION_REASONS = exports.DocumentDisallowedReason = exports.TitleInsuranceDocumentRejectionReason = exports.ExternalBankAccountDocumentRejectionReason = exports.LienRefiDocumentRejectionReason = exports.VerificationDocumentPendingReason = exports.ContingencyLienType = exports.CustomDocumentRequestAttributeKey = exports.SUPPLIED_SINGLE_DOCUMENT_UPLOAD_REQUEST_STATUSES = exports.ACTIVE_SINGLE_DOCUMENT_UPLOAD_REQUEST_STATUSES = exports.INACTIVE_SINGLE_DOCUMENT_UPLOAD_REQUEST_STATUSES = exports.IS_ACTIVE_BY_SINGLE_DOCUMENT_UPLOAD_REQUEST_STATUS = exports.SingleDocumentUploadRequestStatus = exports.BROKER_UPLOAD_DOCUMENT_TYPE_BY_LIEN_REFI_DOCUMENT_TYPE = exports.BROKER_UPLOADABLE_LIEN_REFI_DOCUMENT_TYPES = exports.PENDING_DOCUMENT_TASK_TYPE_TO_DOCUMENT_UPLOAD_TYPES = exports.TEXAS_ATTORNEY_REVIEW_TITLE_DOCUMENT_UPLOAD_TYPES = exports.SUPPORTING_DOCUMENT_PENDING_DOCUMENT_TASK_TYPES = exports.PENDING_CUSTOMER_ACTION_FRAUD_PENDING_DOCUMENT_TASK_TYPES = exports.CIP_PENDING_DOCUMENT_TASK_TYPES = exports.CUSTOMER_FRAUD_PENDING_DOCUMENT_TASK_TYPES = exports.CUSTOMER_SUPPRESSED_FRAUD_PENDING_DOCUMENT_TASK_TYPES = exports.isApplicantScopedPendingDocumentTaskType = exports.FRAUD_PENDING_DOCUMENT_TASK_TYPES = exports.PendingDocumentTaskType = exports.isTerminalPendingDocumentTaskStatus = exports.TERMINAL_PENDING_DOCUMENT_TASK_STATUSES = exports.NON_ABANDONED_PENDING_DOCUMENT_TASK_STATUSES = exports.ACTIVE_PENDING_DOCUMENT_TASK_STATUSES = exports.PendingDocumentTaskStatus = void 0;
const contingency_1 = require("./contingency");
const documentUpload_1 = require("./documentUpload");
// These status should be irreversible so pending => inProgress => completed. Pending/In progress => abandoned. Completed/Abandoned are terminal states
/** @TranslateToPython @TranslateToEnum */
var PendingDocumentTaskStatus;
(function (PendingDocumentTaskStatus) {
    // We created the pending document task, but havent requested any documents yet
    // There is no single document upload request in pending or inProgress state
    // There is no single document upload request in completed state with isRejected = false
    PendingDocumentTaskStatus["pending"] = "pending";
    // The request is sent to customer but no action is taken by customer yet
    // There is at least one single document upload request that is in the pending state
    PendingDocumentTaskStatus["requested"] = "requested";
    // Customer has uploaded at least 1 document that needs to be reviewed by Aven
    // There is at least one single document upload request that is in the inProgress state
    PendingDocumentTaskStatus["inProgress"] = "in_progress";
    // The task is completed and no further action is allowed
    // There is no single document upload request in pending or inProgress state
    // There is at least one single document upload request in completed state with isRejected = false
    PendingDocumentTaskStatus["completed"] = "completed";
    // The task is abandoned and no further action is allowed
    // Must be set to this status manually
    PendingDocumentTaskStatus["abandoned"] = "abandoned";
})(PendingDocumentTaskStatus || (exports.PendingDocumentTaskStatus = PendingDocumentTaskStatus = {}));
exports.ACTIVE_PENDING_DOCUMENT_TASK_STATUSES = [PendingDocumentTaskStatus.pending, PendingDocumentTaskStatus.requested, PendingDocumentTaskStatus.inProgress];
exports.NON_ABANDONED_PENDING_DOCUMENT_TASK_STATUSES = Object.values(PendingDocumentTaskStatus).filter((status) => status !== PendingDocumentTaskStatus.abandoned);
// completed/abandoned are the irreversible terminal states (see enum doc comment above).
exports.TERMINAL_PENDING_DOCUMENT_TASK_STATUSES = [PendingDocumentTaskStatus.completed, PendingDocumentTaskStatus.abandoned];
const isTerminalPendingDocumentTaskStatus = (status) => exports.TERMINAL_PENDING_DOCUMENT_TASK_STATUSES.includes(status);
exports.isTerminalPendingDocumentTaskStatus = isTerminalPendingDocumentTaskStatus;
/** @TranslateToPython @TranslateToEnum */
var PendingDocumentTaskType;
(function (PendingDocumentTaskType) {
    PendingDocumentTaskType["incomeVerification"] = "income_verification";
    PendingDocumentTaskType["fraud"] = "fraud";
    PendingDocumentTaskType["cip"] = "cip";
    PendingDocumentTaskType["fraudDriverLicense"] = "fraudDriverLicense";
    // Generic document request out of the "Post Notarization Reviews" condition (fraud / OFAC / CIP).
    // A pure communication/collection bridge to the borrower or LO — NOT a status driver: completing this
    // task does NOT clear any OGC. The fraud/OFAC/CIP mirror OGCs stay derived from their underlying review
    // state, so this task type is intentionally NOT wired into documentTaskOgcResolver.
    PendingDocumentTaskType["postNotarizationReview"] = "postNotarizationReview";
    // validate balance on account
    PendingDocumentTaskType["statementReservesVerification"] = "statementReservesVerification";
    /** Some UCC card applications will upload bank statements to verify how much in assets the applicants have. */
    PendingDocumentTaskType["bankStatementAssetVerification"] = "bankStatementAssetVerification";
    PendingDocumentTaskType["lienRefiMortgageStatement"] = "lienRefiMortgageStatement";
    PendingDocumentTaskType["lienRefiSignedBorrowerAuth"] = "lienRefiSignedBorrowerAuth";
    PendingDocumentTaskType["lienRefiPayoffQuote"] = "lienRefiPayoffQuote";
    PendingDocumentTaskType["lienRefiReleaseConfirmation"] = "lienRefiReleaseConfirmation";
    PendingDocumentTaskType["lienPositionReview"] = "lienPositionReview";
    PendingDocumentTaskType["lienRefiPayoffPaymentConfirmation"] = "lienRefiPayoffPaymentConfirmation";
    // Ordinary title-insurance pending documents, represented by one task per title lien.
    PendingDocumentTaskType["titleInsurance"] = "titleInsurance";
    // One manually reviewed document task per removed co-owner action; never auto-clears its OGC.
    PendingDocumentTaskType["removedCoOwner"] = "removedCoOwner";
    // Texas title-insurance closing package (the title company's documents in TEXAS_ATTORNEY_REVIEW_TITLE_DOCUMENT_UPLOAD_TYPES)
    // and its attorney approval. Loan-application-scoped (not owned by a LienRefi); collected/reviewed by ops.
    // These clear the titleInsuranceClosingPackage / closingPackageAttorneyApproval blockNotarySessionScheduling OGCs (see documentTaskOgcResolver).
    PendingDocumentTaskType["titleInsuranceClosingPackage"] = "titleInsuranceClosingPackage";
    PendingDocumentTaskType["closingPackageAttorneyApproval"] = "closingPackageAttorneyApproval";
    // Early Bank Connection: applicant uploads a bank statement for ops to manually verify a staged bank account that
    // failed automated (GIACT/Plaid) verification. Distinct from bankStatementAssetVerification (UCC asset check).
    // Completing this task clears the externalBankAccountVerification blockNotarySessionScheduling OGC (see documentTaskOgcResolver).
    PendingDocumentTaskType["externalBankAccountVerification"] = "externalBankAccountVerification";
    // Trust-owned home with no last-transfer document available: applicant uploads a certificate of trust. Completing this task clears the trustVerification blockNotarySessionScheduling OGC (see documentTaskOgcResolver).
    PendingDocumentTaskType["trustVerification"] = "trustVerification";
    // Fraud related pending document tasks
    // Mainly verifying residency at address, as ownership is handled alternatively for home
    PendingDocumentTaskType["addressVerificationHome"] = "addressVerificationHome";
    // Verifying residency at address or ownership if possible
    PendingDocumentTaskType["addressVerificationUcc"] = "addressVerificationUcc";
    // Verifying ownership
    PendingDocumentTaskType["addressVerificationInvestment"] = "addressVerificationInvestment";
    PendingDocumentTaskType["bankStatement"] = "bankStatement";
    PendingDocumentTaskType["cipSsnDocuments"] = "cipSsnDocuments";
    PendingDocumentTaskType["ssnCard"] = "ssnCard";
    PendingDocumentTaskType["cipAddressDocuments"] = "cipAddressDocuments";
    PendingDocumentTaskType["cipDobDocuments"] = "cipDobDocuments";
    PendingDocumentTaskType["cipNameDocuments"] = "cipNameDocuments";
    PendingDocumentTaskType["firstFormId"] = "firstFormId";
    PendingDocumentTaskType["secondFormId"] = "secondFormId";
    PendingDocumentTaskType["idCoOwnerOnly"] = "idCoOwnerOnly";
    PendingDocumentTaskType["voiceVerification"] = "voiceVerification";
    // The applicant verifies their identity with Persona (photo ID and selfie) in the app.
    PendingDocumentTaskType["personaSession"] = "personaSession";
    PendingDocumentTaskType["employmentVerification"] = "employmentVerification";
})(PendingDocumentTaskType || (exports.PendingDocumentTaskType = PendingDocumentTaskType = {}));
exports.FRAUD_PENDING_DOCUMENT_TASK_TYPES = [
    PendingDocumentTaskType.addressVerificationHome,
    PendingDocumentTaskType.addressVerificationUcc,
    PendingDocumentTaskType.addressVerificationInvestment,
    PendingDocumentTaskType.bankStatement,
    PendingDocumentTaskType.cipSsnDocuments,
    PendingDocumentTaskType.ssnCard,
    PendingDocumentTaskType.cipAddressDocuments,
    PendingDocumentTaskType.cipDobDocuments,
    PendingDocumentTaskType.cipNameDocuments,
    PendingDocumentTaskType.firstFormId,
    PendingDocumentTaskType.secondFormId,
    PendingDocumentTaskType.idCoOwnerOnly,
    PendingDocumentTaskType.voiceVerification,
    PendingDocumentTaskType.personaSession,
];
const isApplicantScopedPendingDocumentTaskType = (taskType) => exports.FRAUD_PENDING_DOCUMENT_TASK_TYPES.some((applicantScopedTaskType) => applicantScopedTaskType === taskType);
exports.isApplicantScopedPendingDocumentTaskType = isApplicantScopedPendingDocumentTaskType;
// Suppressed from borrower document flows and automatic customer communications, not from internal review.
/** @TranslateToPython */
exports.CUSTOMER_SUPPRESSED_FRAUD_PENDING_DOCUMENT_TASK_TYPES = [PendingDocumentTaskType.voiceVerification];
exports.CUSTOMER_FRAUD_PENDING_DOCUMENT_TASK_TYPES = exports.FRAUD_PENDING_DOCUMENT_TASK_TYPES.filter((type) => !exports.CUSTOMER_SUPPRESSED_FRAUD_PENDING_DOCUMENT_TASK_TYPES.includes(type));
// The granular CIP evidence asks (SSN / address / DOB / name documents) the fraud portal collects. They are requested
// through the same ops endpoint as the fraud asks and still set fraud_flag.pending_customer_action = true, but the
// obligation behind them is the CIP requirement, which outlives a fraud-flag clear. Plain `cip` is not here either:
// it is the CIP flow's own task type, requested through the CIP verification endpoint.
exports.CIP_PENDING_DOCUMENT_TASK_TYPES = [
    PendingDocumentTaskType.cipSsnDocuments,
    PendingDocumentTaskType.cipAddressDocuments,
    PendingDocumentTaskType.cipDobDocuments,
    PendingDocumentTaskType.cipNameDocuments,
];
// Fraud pending-document task types whose request sets fraud_flag.pending_customer_action = true and whose open
// requests are torn down when that flag clears. Shared by the data-integrity runners
// (fraudPendingDocumentTaskUploadWithoutFlagClearRunner)
// and the fraud-clear teardown so the enforced invariant and its cleanup cannot drift apart. The CIP asks above are
// excluded so clearing fraud does not cancel them; plain `cip` is excluded because the CIP verification flow requests
// it and sets loan_application.awaitingApplicantFraudVerificationDocs instead.
exports.PENDING_CUSTOMER_ACTION_FRAUD_PENDING_DOCUMENT_TASK_TYPES = [
    PendingDocumentTaskType.fraud,
    PendingDocumentTaskType.fraudDriverLicense,
    ...exports.CUSTOMER_FRAUD_PENDING_DOCUMENT_TASK_TYPES.filter((type) => !exports.CIP_PENDING_DOCUMENT_TASK_TYPES.includes(type)),
];
/**
 * Whether a loose SUPPORTING_DOCUMENT upload may be counted against a task of this type. The borrower
 * uploads these outside any specific request, so they are attributed to every active task that accepts
 * them. Exhaustive on purpose: a new task type does not compile until someone decides.
 *
 * The per-lien conditions are false because their tasks are per lien, and a loose document carries
 * nothing that says which lien it belongs to.
 */
const ACCEPTS_SUPPORTING_DOCUMENTS = {
    [PendingDocumentTaskType.incomeVerification]: true,
    [PendingDocumentTaskType.fraud]: true,
    [PendingDocumentTaskType.cip]: true,
    [PendingDocumentTaskType.fraudDriverLicense]: true,
    [PendingDocumentTaskType.postNotarizationReview]: true,
    [PendingDocumentTaskType.statementReservesVerification]: true,
    [PendingDocumentTaskType.bankStatementAssetVerification]: true,
    [PendingDocumentTaskType.lienRefiMortgageStatement]: true,
    [PendingDocumentTaskType.lienRefiSignedBorrowerAuth]: true,
    [PendingDocumentTaskType.lienRefiPayoffQuote]: true,
    [PendingDocumentTaskType.lienRefiReleaseConfirmation]: true,
    [PendingDocumentTaskType.lienRefiPayoffPaymentConfirmation]: true,
    [PendingDocumentTaskType.titleInsurance]: false,
    [PendingDocumentTaskType.lienPositionReview]: false,
    [PendingDocumentTaskType.removedCoOwner]: false,
    [PendingDocumentTaskType.titleInsuranceClosingPackage]: false,
    [PendingDocumentTaskType.closingPackageAttorneyApproval]: true,
    [PendingDocumentTaskType.externalBankAccountVerification]: false,
    [PendingDocumentTaskType.addressVerificationHome]: true,
    [PendingDocumentTaskType.addressVerificationUcc]: true,
    [PendingDocumentTaskType.addressVerificationInvestment]: true,
    [PendingDocumentTaskType.bankStatement]: true,
    [PendingDocumentTaskType.cipSsnDocuments]: true,
    [PendingDocumentTaskType.ssnCard]: true,
    [PendingDocumentTaskType.cipAddressDocuments]: true,
    [PendingDocumentTaskType.cipDobDocuments]: true,
    [PendingDocumentTaskType.cipNameDocuments]: true,
    [PendingDocumentTaskType.firstFormId]: true,
    [PendingDocumentTaskType.secondFormId]: true,
    [PendingDocumentTaskType.idCoOwnerOnly]: true,
    [PendingDocumentTaskType.voiceVerification]: false,
    [PendingDocumentTaskType.personaSession]: false,
    [PendingDocumentTaskType.employmentVerification]: true,
    [PendingDocumentTaskType.trustVerification]: false,
};
exports.SUPPORTING_DOCUMENT_PENDING_DOCUMENT_TASK_TYPES = Object.values(PendingDocumentTaskType).filter((taskType) => ACCEPTS_SUPPORTING_DOCUMENTS[taskType]);
// The Texas title documents the attorney reviews alongside Aven's closing package. The titleInsuranceClosingPackage task
// requests each one, so its OGC blocks notary scheduling until all of them are uploaded and approved.
exports.TEXAS_ATTORNEY_REVIEW_TITLE_DOCUMENT_UPLOAD_TYPES = [
    documentUpload_1.DocumentUploadType.TITLE_INSURANCE_CLOSING_PACKAGE,
    documentUpload_1.DocumentUploadType.TITLE_INSURANCE_VESTING_DEED,
    documentUpload_1.DocumentUploadType.TITLE_INSURANCE_TAX_CERTIFICATE,
];
// Source: https://app.asana.com/1/1112936964823799/project/1204621113015679/task/1217446918419845?focus=true
// Remaining PendingDocumentTaskType slots are not yet mapped and will be filled in separately
exports.PENDING_DOCUMENT_TASK_TYPE_TO_DOCUMENT_UPLOAD_TYPES = {
    [PendingDocumentTaskType.addressVerificationHome]: [
        documentUpload_1.DocumentUploadType.PAY_STUB,
        documentUpload_1.DocumentUploadType.US_DRIVERS_LICENSE,
        documentUpload_1.DocumentUploadType.US_STATE_ID_CARD,
        documentUpload_1.DocumentUploadType.FORM_1099,
        documentUpload_1.DocumentUploadType.W2,
        documentUpload_1.DocumentUploadType.RETIREMENT,
        documentUpload_1.DocumentUploadType.PENSION,
    ],
    [PendingDocumentTaskType.addressVerificationUcc]: [
        documentUpload_1.DocumentUploadType.PAY_STUB,
        documentUpload_1.DocumentUploadType.US_DRIVERS_LICENSE,
        documentUpload_1.DocumentUploadType.US_STATE_ID_CARD,
        documentUpload_1.DocumentUploadType.FORM_1099,
        documentUpload_1.DocumentUploadType.W2,
        documentUpload_1.DocumentUploadType.RETIREMENT,
        documentUpload_1.DocumentUploadType.PENSION,
        documentUpload_1.DocumentUploadType.PROPERTY_TAX_STATEMENT,
        documentUpload_1.DocumentUploadType.MORTGAGE_STATEMENT,
        documentUpload_1.DocumentUploadType.UTILITY_BILL,
        documentUpload_1.DocumentUploadType.LEASE_AGREEMENT,
    ],
    [PendingDocumentTaskType.addressVerificationInvestment]: [documentUpload_1.DocumentUploadType.PROPERTY_TAX_STATEMENT, documentUpload_1.DocumentUploadType.MORTGAGE_STATEMENT, documentUpload_1.DocumentUploadType.UTILITY_BILL],
    [PendingDocumentTaskType.bankStatement]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [PendingDocumentTaskType.cipSsnDocuments]: [
        documentUpload_1.DocumentUploadType.SOCIAL_SECURITY_CARD,
        documentUpload_1.DocumentUploadType.TAX_RETURN,
        documentUpload_1.DocumentUploadType.W2,
        documentUpload_1.DocumentUploadType.FORM_1099,
        documentUpload_1.DocumentUploadType.ITIN_ASSIGNMENT_LETTER_CP565,
    ],
    [PendingDocumentTaskType.ssnCard]: [documentUpload_1.DocumentUploadType.SOCIAL_SECURITY_CARD],
    [PendingDocumentTaskType.firstFormId]: [
        documentUpload_1.DocumentUploadType.US_DRIVERS_LICENSE,
        documentUpload_1.DocumentUploadType.US_STATE_ID_CARD,
        documentUpload_1.DocumentUploadType.US_PASSPORT,
        documentUpload_1.DocumentUploadType.US_PASSPORT_CARD,
        documentUpload_1.DocumentUploadType.US_PERMANENT_RESIDENT_CARD,
    ],
    [PendingDocumentTaskType.secondFormId]: [
        documentUpload_1.DocumentUploadType.US_BIRTH_CERTIFICATE,
        documentUpload_1.DocumentUploadType.US_MILITARY_ID,
        documentUpload_1.DocumentUploadType.GLOBAL_ENTRY_CARD,
        documentUpload_1.DocumentUploadType.US_CERTIFICATE_OF_NATURALIZATION,
        documentUpload_1.DocumentUploadType.US_PASSPORT,
        documentUpload_1.DocumentUploadType.US_PASSPORT_CARD,
        documentUpload_1.DocumentUploadType.FOREIGN_PASSPORT,
    ],
    [PendingDocumentTaskType.idCoOwnerOnly]: [documentUpload_1.DocumentUploadType.US_EMPLOYMENT_AUTHORIZATION_CARD],
    [PendingDocumentTaskType.voiceVerification]: [documentUpload_1.DocumentUploadType.VOICE_VERIFICATION],
    [PendingDocumentTaskType.personaSession]: [documentUpload_1.DocumentUploadType.PERSONA_SESSION],
    [PendingDocumentTaskType.cipNameDocuments]: [
        documentUpload_1.DocumentUploadType.US_DRIVERS_LICENSE,
        documentUpload_1.DocumentUploadType.US_STATE_ID_CARD,
        documentUpload_1.DocumentUploadType.US_PASSPORT,
        documentUpload_1.DocumentUploadType.US_PASSPORT_CARD,
        documentUpload_1.DocumentUploadType.US_PERMANENT_RESIDENT_CARD,
        documentUpload_1.DocumentUploadType.TRIBAL_ID_CARD,
        documentUpload_1.DocumentUploadType.US_DEPT_OF_STATE_DRIVERS_LICENSE,
    ],
    [PendingDocumentTaskType.cipAddressDocuments]: [
        documentUpload_1.DocumentUploadType.PAY_STUB,
        documentUpload_1.DocumentUploadType.US_DRIVERS_LICENSE,
        documentUpload_1.DocumentUploadType.FORM_1099,
        documentUpload_1.DocumentUploadType.W2,
        documentUpload_1.DocumentUploadType.US_STATE_ID_CARD,
        documentUpload_1.DocumentUploadType.RETIREMENT,
    ],
    [PendingDocumentTaskType.cipDobDocuments]: [
        documentUpload_1.DocumentUploadType.US_DRIVERS_LICENSE,
        documentUpload_1.DocumentUploadType.US_STATE_ID_CARD,
        documentUpload_1.DocumentUploadType.US_PASSPORT,
        documentUpload_1.DocumentUploadType.US_PASSPORT_CARD,
        documentUpload_1.DocumentUploadType.US_PERMANENT_RESIDENT_CARD,
        documentUpload_1.DocumentUploadType.TRIBAL_ID_CARD,
        documentUpload_1.DocumentUploadType.US_DEPT_OF_STATE_DRIVERS_LICENSE,
        documentUpload_1.DocumentUploadType.US_BIRTH_CERTIFICATE,
    ],
    [PendingDocumentTaskType.employmentVerification]: [documentUpload_1.DocumentUploadType.PAY_STUB, documentUpload_1.DocumentUploadType.W2, documentUpload_1.DocumentUploadType.TAX_RETURN, documentUpload_1.DocumentUploadType.FORM_1099],
    // Trust-owned homes require a certificate of trust when no last-transfer document is available.
    [PendingDocumentTaskType.trustVerification]: [documentUpload_1.DocumentUploadType.CERTIFICATE_OF_TRUST],
    [PendingDocumentTaskType.titleInsurance]: [documentUpload_1.DocumentUploadType.HELOC_REFI_SATISFACTION_OF_MORTGAGE, documentUpload_1.DocumentUploadType.STATEMENT_OF_INFORMATION],
    // Both per-lien conditions ask the same of a lien: the release that clears it, or the Statement of
    // Information that disowns it.
    [PendingDocumentTaskType.lienPositionReview]: [documentUpload_1.DocumentUploadType.HELOC_REFI_SATISFACTION_OF_MORTGAGE, documentUpload_1.DocumentUploadType.STATEMENT_OF_INFORMATION],
    [PendingDocumentTaskType.externalBankAccountVerification]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.VOIDED_CHECK],
};
/**
 * Lien-refi document types a broker can upload on the borrower's behalf from the partner dashboard's
 * prior-lien-release detail views. Curated to the docs a broker would realistically supply (the
 * system-generated payment confirmation is excluded). The signed borrower authorization is included so
 * the LO can supply it for the pre-notary priorLienReleaseDocuments flow. Shared by the contract,
 * backend, and the partner-dashboard upload dropdown.
 */
/** @TranslateToPython */
exports.BROKER_UPLOADABLE_LIEN_REFI_DOCUMENT_TYPES = [
    PendingDocumentTaskType.lienRefiMortgageStatement,
    PendingDocumentTaskType.lienRefiPayoffQuote,
    PendingDocumentTaskType.lienRefiReleaseConfirmation,
    PendingDocumentTaskType.lienRefiSignedBorrowerAuth,
];
/**
 * Maps each broker-uploadable lien-refi document type to the DocumentUploadType the borrower upload
 * path uses for it, so a partner-dashboard upload is stored and classified exactly like the borrower's.
 */
exports.BROKER_UPLOAD_DOCUMENT_TYPE_BY_LIEN_REFI_DOCUMENT_TYPE = {
    [PendingDocumentTaskType.lienRefiMortgageStatement]: documentUpload_1.DocumentUploadType.MORTGAGE_STATEMENT,
    [PendingDocumentTaskType.lienRefiPayoffQuote]: documentUpload_1.DocumentUploadType.HELOC_REFI_PAYOFF_QUOTE,
    [PendingDocumentTaskType.lienRefiReleaseConfirmation]: documentUpload_1.DocumentUploadType.HELOC_REFI_SATISFACTION_OF_MORTGAGE,
    [PendingDocumentTaskType.lienRefiSignedBorrowerAuth]: documentUpload_1.DocumentUploadType.HELOC_REFI_SIGNED_BORROWER_AUTH,
};
// These status should be irreversible so pending => inProgress => completed. Pending/In progress => abandoned. Completed/abandoned are terminal states
var SingleDocumentUploadRequestStatus;
(function (SingleDocumentUploadRequestStatus) {
    // The request is sent to customer but no action is taken by customer yet
    SingleDocumentUploadRequestStatus["pending"] = "pending";
    // Customer has uploaded the document and needs to be reviewed by Aven
    SingleDocumentUploadRequestStatus["inProgress"] = "in_progress";
    // The document review is completed by Aven. Could be approved or denied. one and only one of [approved_at, denied_at] should be set
    SingleDocumentUploadRequestStatus["completed"] = "completed";
    // The task is abandoned and no further action is allowed
    SingleDocumentUploadRequestStatus["abandoned"] = "abandoned";
})(SingleDocumentUploadRequestStatus || (exports.SingleDocumentUploadRequestStatus = SingleDocumentUploadRequestStatus = {}));
exports.IS_ACTIVE_BY_SINGLE_DOCUMENT_UPLOAD_REQUEST_STATUS = {
    [SingleDocumentUploadRequestStatus.pending]: true,
    [SingleDocumentUploadRequestStatus.inProgress]: true,
    [SingleDocumentUploadRequestStatus.completed]: false,
    [SingleDocumentUploadRequestStatus.abandoned]: false,
};
exports.INACTIVE_SINGLE_DOCUMENT_UPLOAD_REQUEST_STATUSES = Object.values(SingleDocumentUploadRequestStatus).filter((status) => !exports.IS_ACTIVE_BY_SINGLE_DOCUMENT_UPLOAD_REQUEST_STATUS[status]);
exports.ACTIVE_SINGLE_DOCUMENT_UPLOAD_REQUEST_STATUSES = Object.values(SingleDocumentUploadRequestStatus).filter((status) => exports.IS_ACTIVE_BY_SINGLE_DOCUMENT_UPLOAD_REQUEST_STATUS[status]);
/**
 * A request that has a document attached — uploaded and awaiting review, or reviewed. `abandoned` is
 * terminal like `completed` but supplies nothing, so readers counting borrower progress need this set
 * rather than "not pending".
 */
exports.SUPPLIED_SINGLE_DOCUMENT_UPLOAD_REQUEST_STATUSES = [SingleDocumentUploadRequestStatus.inProgress, SingleDocumentUploadRequestStatus.completed];
var CustomDocumentRequestAttributeKey;
(function (CustomDocumentRequestAttributeKey) {
    // specifies a doc year, applicable for incomeVerification
    CustomDocumentRequestAttributeKey["year"] = "year";
    // Which post-notarization review sub-check (fraud / OFAC / CIP) this requested document/action belongs to.
    // Lets the conditions-page frontend link the requested doc back to its sub-check row. Value: PostNotarizationSubCheck.
    // Whether a requested document is fulfilled by upload vs. an action is NOT stored per-request — it's derived
    // from the DocumentUploadType via NON_UPLOAD_DOCUMENT_UPLOAD_TYPES (see documentUpload.ts).
    CustomDocumentRequestAttributeKey["postNotarizationSubCheck"] = "postNotarizationSubCheck";
    // Identifies the lien for title insurance and lien-position review tasks and requests.
    CustomDocumentRequestAttributeKey["lien"] = "lien";
    // The removal action this task and its document requests concern.
    CustomDocumentRequestAttributeKey["removedCoOwner"] = "removedCoOwner";
})(CustomDocumentRequestAttributeKey || (exports.CustomDocumentRequestAttributeKey = CustomDocumentRequestAttributeKey = {}));
var ContingencyLienType;
(function (ContingencyLienType) {
    ContingencyLienType["MORTGAGE"] = "MORTGAGE";
    ContingencyLienType["JUDGMENT"] = "JUDGMENT";
})(ContingencyLienType || (exports.ContingencyLienType = ContingencyLienType = {}));
// @TranslateToPython
var VerificationDocumentPendingReason;
(function (VerificationDocumentPendingReason) {
    VerificationDocumentPendingReason["INITIAL"] = "INITIAL";
    VerificationDocumentPendingReason["INSUFFICIENT_INCOME"] = "INSUFFICIENT_INCOME";
    VerificationDocumentPendingReason["INCORRECT_DOC_TYPE"] = "INCORRECT_DOC_TYPE";
    VerificationDocumentPendingReason["INCOMPLETE_PAGE"] = "INCOMPLETE_PAGE";
    VerificationDocumentPendingReason["DOCUMENT_IS_A_DUPLICATE"] = "DOCUMENT_IS_A_DUPLICATE";
    VerificationDocumentPendingReason["DOCUMENT_IS_FOR_A_NON_APPLICANT"] = "DOCUMENT_IS_FOR_A_NON_APPLICANT";
    VerificationDocumentPendingReason["DOCUMENT_IS_A_CONTINUATION_PAGE"] = "DOCUMENT_IS_A_CONTINUATION_PAGE";
    VerificationDocumentPendingReason["NON_INCOME_DOCUMENT"] = "NON_INCOME_DOCUMENT";
    VerificationDocumentPendingReason["DOCUMENT_IS_CROPPED"] = "DOCUMENT_IS_CROPPED";
    VerificationDocumentPendingReason["NO_FILLED_DATA"] = "NO_FILLED_DATA";
    VerificationDocumentPendingReason["OUTDATED_DOC"] = "OUTDATED_DOC";
    VerificationDocumentPendingReason["MISSING_INFO"] = "MISSING_INFO";
    VerificationDocumentPendingReason["MISMATCHED_INFO"] = "MISMATCHED_INFO";
    VerificationDocumentPendingReason["CROPPED_BLURRY"] = "CROPPED_BLURRY";
    VerificationDocumentPendingReason["SUSPICIOUS_DOC"] = "SUSPICIOUS_DOC";
    VerificationDocumentPendingReason["PICTURE_OF_SCREEN"] = "PICTURE_OF_SCREEN";
    VerificationDocumentPendingReason["PAID_TO_ENTITY"] = "PAID_TO_ENTITY";
    VerificationDocumentPendingReason["INVALID_NOO_DOC"] = "INVALID_NOO_DOC";
    VerificationDocumentPendingReason["NO_SCREENSHOTS"] = "NO_SCREENSHOTS";
    VerificationDocumentPendingReason["ALL_PAGES_OF_BANK_STATEMENTS_REQUIRED"] = "ALL_PAGES_OF_BANK_STATEMENTS_REQUIRED";
    VerificationDocumentPendingReason["DOC_TYPE_NOT_ALLOWED"] = "DOC_TYPE_NOT_ALLOWED";
    VerificationDocumentPendingReason["DOC_IS_DUPLICATE_UPLOAD"] = "DOC_IS_DUPLICATE_UPLOAD";
    VerificationDocumentPendingReason["RECEIVED_DOCS_INSUFFICIENT_REQUIRE_Y_MINUS_ONE"] = "RECEIVED_DOCS_INSUFFICIENT_REQUIRE_Y_MINUS_ONE";
    VerificationDocumentPendingReason["PASSWORD_PROTECTED_DOC"] = "PASSWORD_PROTECTED_DOC";
    VerificationDocumentPendingReason["OCROLUS_AUTHENTICITY_SCORE_TOO_LOW"] = "OCROLUS_AUTHENTICITY_SCORE_TOO_LOW";
    VerificationDocumentPendingReason["OCROLUS_UNSUPPORTED_DOC"] = "OCROLUS_UNSUPPORTED_DOC";
    VerificationDocumentPendingReason["GOOGLE_UNSUPPORTED_DOC"] = "GOOGLE_UNSUPPORTED_DOC";
    VerificationDocumentPendingReason["GEMINI_UNSUPPORTED_DOC"] = "GEMINI_UNSUPPORTED_DOC";
    VerificationDocumentPendingReason["OTHER"] = "OTHER";
})(VerificationDocumentPendingReason || (exports.VerificationDocumentPendingReason = VerificationDocumentPendingReason = {}));
/** @TranslateToPython */
var LienRefiDocumentRejectionReason;
(function (LienRefiDocumentRejectionReason) {
    LienRefiDocumentRejectionReason["LIEN_REFI_INCORRECT_MORTGAGE_STATEMENT"] = "LIEN_REFI_INCORRECT_MORTGAGE_STATEMENT";
    LienRefiDocumentRejectionReason["LIEN_REFI_INCOMPLETE_PAGE"] = "LIEN_REFI_INCOMPLETE_PAGE";
    LienRefiDocumentRejectionReason["LIEN_REFI_OUTDATED_DOC"] = "LIEN_REFI_OUTDATED_DOC";
    LienRefiDocumentRejectionReason["LIEN_REFI_MISSING_INFO"] = "LIEN_REFI_MISSING_INFO";
    LienRefiDocumentRejectionReason["DIGITAL_SIGNATURE_NOT_ACCEPTED"] = "DIGITAL_SIGNATURE_NOT_ACCEPTED";
    LienRefiDocumentRejectionReason["LIEN_REFI_MISSING_LOAN_NUMBER"] = "LIEN_REFI_MISSING_LOAN_NUMBER";
    LienRefiDocumentRejectionReason["LIEN_REFI_MISSING_SIGNATURE"] = "LIEN_REFI_MISSING_SIGNATURE";
    LienRefiDocumentRejectionReason["LIEN_REFI_OTHER"] = "LIEN_REFI_OTHER";
})(LienRefiDocumentRejectionReason || (exports.LienRefiDocumentRejectionReason = LienRefiDocumentRejectionReason = {}));
/** @TranslateToPython */
var ExternalBankAccountDocumentRejectionReason;
(function (ExternalBankAccountDocumentRejectionReason) {
    ExternalBankAccountDocumentRejectionReason["EXTERNAL_BANK_ACCOUNT_INCORRECT_DOCUMENT"] = "EXTERNAL_BANK_ACCOUNT_INCORRECT_DOCUMENT";
    ExternalBankAccountDocumentRejectionReason["EXTERNAL_BANK_ACCOUNT_MISSING_INFO"] = "EXTERNAL_BANK_ACCOUNT_MISSING_INFO";
    ExternalBankAccountDocumentRejectionReason["EXTERNAL_BANK_ACCOUNT_CANNOT_VERIFY"] = "EXTERNAL_BANK_ACCOUNT_CANNOT_VERIFY";
    ExternalBankAccountDocumentRejectionReason["EXTERNAL_BANK_ACCOUNT_INCORRECT_ACCOUNT_INFO"] = "EXTERNAL_BANK_ACCOUNT_INCORRECT_ACCOUNT_INFO";
})(ExternalBankAccountDocumentRejectionReason || (exports.ExternalBankAccountDocumentRejectionReason = ExternalBankAccountDocumentRejectionReason = {}));
/**
 * Rejections that only ordinary title produces. A judgment lien is the one case where the document we
 * accept depends on what the borrower told us about the lien, so turning a Statement of Information
 * down is itself a statement about the lien rather than about the document.
 */
/** @TranslateToPython */
var TitleInsuranceDocumentRejectionReason;
(function (TitleInsuranceDocumentRejectionReason) {
    TitleInsuranceDocumentRejectionReason["JUDGMENT_LIEN_NEEDS_RELEASE"] = "JUDGMENT_LIEN_NEEDS_RELEASE";
})(TitleInsuranceDocumentRejectionReason || (exports.TitleInsuranceDocumentRejectionReason = TitleInsuranceDocumentRejectionReason = {}));
/** @TranslateToPython */
var DocumentDisallowedReason;
(function (DocumentDisallowedReason) {
    DocumentDisallowedReason["ALLOWED"] = "ALLOWED";
    DocumentDisallowedReason["DISALLOWED_OUTDATED"] = "DISALLOWED_OUTDATED";
    DocumentDisallowedReason["DISALLOWED_DOC_TYPE"] = "DISALLOWED_DOC_TYPE";
})(DocumentDisallowedReason || (exports.DocumentDisallowedReason = DocumentDisallowedReason = {}));
exports.ALL_DOCUMENT_REJECTION_REASONS = [
    ...Object.values(VerificationDocumentPendingReason),
    ...Object.values(DocumentDisallowedReason),
    ...Object.values(LienRefiDocumentRejectionReason),
    ...Object.values(TitleInsuranceDocumentRejectionReason),
    ...Object.values(ExternalBankAccountDocumentRejectionReason),
];
exports.REJECTION_REASONS_BY_PENDING_DOCUMENT_TASK_TYPE = {
    [PendingDocumentTaskType.externalBankAccountVerification]: Object.values(ExternalBankAccountDocumentRejectionReason),
};
/** @TranslateToPython */
exports.HUMAN_READABLE_REJECTION_REASON = {
    [VerificationDocumentPendingReason.INITIAL]: 'we were unable to verify the information',
    [VerificationDocumentPendingReason.INSUFFICIENT_INCOME]: 'it was less than your stated income',
    [VerificationDocumentPendingReason.INCORRECT_DOC_TYPE]: 'it was an incorrect document type',
    [VerificationDocumentPendingReason.INCOMPLETE_PAGE]: 'it was not complete',
    [VerificationDocumentPendingReason.DOCUMENT_IS_A_DUPLICATE]: 'it is a duplicate',
    [VerificationDocumentPendingReason.DOCUMENT_IS_FOR_A_NON_APPLICANT]: 'it was for a non-applicant',
    [VerificationDocumentPendingReason.DOCUMENT_IS_A_CONTINUATION_PAGE]: 'it was a continuation page',
    [VerificationDocumentPendingReason.NON_INCOME_DOCUMENT]: 'it was not an income document',
    [VerificationDocumentPendingReason.DOCUMENT_IS_CROPPED]: 'it was cropped',
    [VerificationDocumentPendingReason.OUTDATED_DOC]: 'it was outdated',
    [VerificationDocumentPendingReason.MISSING_INFO]: 'it was missing some information',
    [VerificationDocumentPendingReason.CROPPED_BLURRY]: 'it was blurry or cropped',
    [VerificationDocumentPendingReason.SUSPICIOUS_DOC]: 'we could not verify the authenticity',
    [VerificationDocumentPendingReason.PICTURE_OF_SCREEN]: 'it was a picture of a screen',
    [VerificationDocumentPendingReason.PAID_TO_ENTITY]: 'the name did not match the applicants',
    [VerificationDocumentPendingReason.INVALID_NOO_DOC]: 'it was an invalid document',
    [VerificationDocumentPendingReason.NO_SCREENSHOTS]: 'it was missing screenshots',
    [VerificationDocumentPendingReason.ALL_PAGES_OF_BANK_STATEMENTS_REQUIRED]: 'it was missing pages',
    [VerificationDocumentPendingReason.DOC_TYPE_NOT_ALLOWED]: 'this document type is not allowed',
    [VerificationDocumentPendingReason.DOC_IS_DUPLICATE_UPLOAD]: 'it is a duplicate',
    [VerificationDocumentPendingReason.RECEIVED_DOCS_INSUFFICIENT_REQUIRE_Y_MINUS_ONE]: "it is insufficient to estimate annual income. Please upload last year's as well",
    [VerificationDocumentPendingReason.PASSWORD_PROTECTED_DOC]: 'it was password protected',
    [VerificationDocumentPendingReason.OCROLUS_AUTHENTICITY_SCORE_TOO_LOW]: 'we could not verify the authenticity',
    [VerificationDocumentPendingReason.OCROLUS_UNSUPPORTED_DOC]: 'this document type is not allowed',
    [VerificationDocumentPendingReason.GOOGLE_UNSUPPORTED_DOC]: 'this document type is not allowed',
    [VerificationDocumentPendingReason.GEMINI_UNSUPPORTED_DOC]: 'this document type is not allowed',
    [VerificationDocumentPendingReason.OTHER]: 'we were unable to verify the information',
    // Maybe deprecate
    [VerificationDocumentPendingReason.NO_FILLED_DATA]: 'some data was missing',
    [VerificationDocumentPendingReason.MISMATCHED_INFO]: 'the data did not match our records',
    [DocumentDisallowedReason.ALLOWED]: '',
    [DocumentDisallowedReason.DISALLOWED_OUTDATED]: 'it was outdated',
    [DocumentDisallowedReason.DISALLOWED_DOC_TYPE]: 'this document type is not allowed',
    [LienRefiDocumentRejectionReason.LIEN_REFI_INCORRECT_MORTGAGE_STATEMENT]: 'incorrect mortgage statement',
    [LienRefiDocumentRejectionReason.LIEN_REFI_INCOMPLETE_PAGE]: 'it was not complete',
    [LienRefiDocumentRejectionReason.LIEN_REFI_OUTDATED_DOC]: 'it was outdated',
    [LienRefiDocumentRejectionReason.LIEN_REFI_MISSING_INFO]: 'it was missing some information',
    [LienRefiDocumentRejectionReason.DIGITAL_SIGNATURE_NOT_ACCEPTED]: 'it had a digital signature',
    [LienRefiDocumentRejectionReason.LIEN_REFI_MISSING_LOAN_NUMBER]: 'it was missing the loan number',
    [LienRefiDocumentRejectionReason.LIEN_REFI_MISSING_SIGNATURE]: 'it was missing a signature',
    [LienRefiDocumentRejectionReason.LIEN_REFI_OTHER]: 'we were unable to verify the information',
    [TitleInsuranceDocumentRejectionReason.JUDGMENT_LIEN_NEEDS_RELEASE]: 'the judgment is still on your property and needs a release',
    [ExternalBankAccountDocumentRejectionReason.EXTERNAL_BANK_ACCOUNT_INCORRECT_DOCUMENT]: 'it was not a bank statement or voided check',
    [ExternalBankAccountDocumentRejectionReason.EXTERNAL_BANK_ACCOUNT_MISSING_INFO]: 'it was missing some information',
    [ExternalBankAccountDocumentRejectionReason.EXTERNAL_BANK_ACCOUNT_CANNOT_VERIFY]: 'the account owner name did not match any applicant names',
    [ExternalBankAccountDocumentRejectionReason.EXTERNAL_BANK_ACCOUNT_INCORRECT_ACCOUNT_INFO]: 'the account information did not match',
};
var FraudPendingDocumentPreviouslyUploadedStatus;
(function (FraudPendingDocumentPreviouslyUploadedStatus) {
    FraudPendingDocumentPreviouslyUploadedStatus["rejected"] = "rejected";
    FraudPendingDocumentPreviouslyUploadedStatus["inProgress"] = "inProgress";
    FraudPendingDocumentPreviouslyUploadedStatus["approved"] = "approved";
})(FraudPendingDocumentPreviouslyUploadedStatus || (exports.FraudPendingDocumentPreviouslyUploadedStatus = FraudPendingDocumentPreviouslyUploadedStatus = {}));
/** Where a fraud document category stands for whoever collects it: still owed, turned down, with us, or accepted. */
var FraudPendingDocumentCategoryReviewStatus;
(function (FraudPendingDocumentCategoryReviewStatus) {
    FraudPendingDocumentCategoryReviewStatus["awaitingUpload"] = "awaitingUpload";
    FraudPendingDocumentCategoryReviewStatus["failed"] = "failed";
    FraudPendingDocumentCategoryReviewStatus["uploaded"] = "uploaded";
    FraudPendingDocumentCategoryReviewStatus["cleared"] = "cleared";
})(FraudPendingDocumentCategoryReviewStatus || (exports.FraudPendingDocumentCategoryReviewStatus = FraudPendingDocumentCategoryReviewStatus = {}));
/** A rejected upload is owed again, just like one never sent. */
exports.OWED_FRAUD_PENDING_DOCUMENT_CATEGORY_REVIEW_STATUSES = [
    FraudPendingDocumentCategoryReviewStatus.awaitingUpload,
    FraudPendingDocumentCategoryReviewStatus.failed,
];
/**
 * The user-facing section label under which a fraud pending-document task type is grouped on the
 * upload portal and in the fraud pending-document email. Multiple task types can share a label.
 */
var FraudPendingDocumentCategoryLabel;
(function (FraudPendingDocumentCategoryLabel) {
    FraudPendingDocumentCategoryLabel["addressVerification"] = "Address Verification";
    FraudPendingDocumentCategoryLabel["bankStatementVerification"] = "Bank Statement Verification";
    FraudPendingDocumentCategoryLabel["ssnVerification"] = "SSN Verification";
    FraudPendingDocumentCategoryLabel["identityVerification"] = "Identity Verification";
    FraudPendingDocumentCategoryLabel["identityVerificationFirstFormId"] = "Identity Verification - 1st Form ID";
    FraudPendingDocumentCategoryLabel["identityVerificationSecondFormId"] = "Identity Verification - 2nd Form ID";
    /** Shared by co-applicant and co-owner ID requests; this category does not identify the applicant's role. */
    FraudPendingDocumentCategoryLabel["coApplicantIdentityVerification"] = "Co-applicant Identity Verification";
    FraudPendingDocumentCategoryLabel["voiceVerification"] = "Voice Verification";
    FraudPendingDocumentCategoryLabel["personaSession"] = "Identity Verification - Photo ID and Selfie";
})(FraudPendingDocumentCategoryLabel || (exports.FraudPendingDocumentCategoryLabel = FraudPendingDocumentCategoryLabel = {}));
exports.LIEN_DOCUMENT_CONDITION_REASON_BY_TASK_TYPE = {
    [PendingDocumentTaskType.titleInsurance]: contingency_1.OriginationContingencyReason.titleInsurance,
    [PendingDocumentTaskType.lienPositionReview]: contingency_1.OriginationContingencyReason.lienPositionReview,
};
const isLienDocumentConditionTaskType = (taskType) => taskType in exports.LIEN_DOCUMENT_CONDITION_REASON_BY_TASK_TYPE;
exports.isLienDocumentConditionTaskType = isLienDocumentConditionTaskType;
const isAttributeScopedPendingDocumentTaskType = (taskType) => (0, exports.isLienDocumentConditionTaskType)(taskType) || taskType === PendingDocumentTaskType.removedCoOwner;
exports.isAttributeScopedPendingDocumentTaskType = isAttributeScopedPendingDocumentTaskType;
/** The same pairing read the other way, for callers that start from the condition. */
exports.LIEN_DOCUMENT_CONDITION_TASK_TYPE_BY_REASON = Object.fromEntries(Object.entries(exports.LIEN_DOCUMENT_CONDITION_REASON_BY_TASK_TYPE).map(([taskType, reason]) => [reason, taskType]));
